const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy flex-column">
      <div className="content flex-column w-100 gap-7x">
        <h2>Политика конфиденциальности ООО ФИРМА «ВОДОКОМФОРТ»</h2>
        <div className="about-info">
          <p className="text-m">
            Настоящая Политика конфиденциальности в отношении обработки
            персональных данных (далее – «Политика конфиденциальности»)
            действует в отношении всей информации, которую ООО фирма
            «ВОДОКОМФОРТ» (ОГРН 1027739216350, ИНН 7705238125, КПП 772501001,
            адрес: 115114, г. Москва, ул. Кожевническая, д. 16, стр. 4) может
            получить о субъекте персональных данных (далее– «Пользователь») во
            время использования сайта, расположенного в сети Интернет по адресу:{" "}
            <a href="https://aquastrong-select.ru">www.aquastrong-select.ru</a>{" "}
            (далее – «Сайт»), а также программ и продуктов ООО фирма
            «ВОДОКОМФОРТ» (далее также – «Сервисы»), размещённых на сайте.
            Использование сервисов Сайта означает безусловное согласие
            Пользователя с настоящей Политикой и указанными в ней условиями
            обработки его персональной информации. В случае несогласия с этими
            условиями Пользователь должен воздержаться от использования
            сервисов. Регистрируясь на Сайте, используя сервисы Сайта, заключая
            договор купли-продажи с ООО фирма «ВОДОКОМФОРТ» и проставляя
            веб-метку в соответствующей графе, Пользователь в соответствии со
            статьей 9 Федерального закона от 27.07.2006 №152-ФЗ «О персональных
            данных» соглашается с тем, что:
          </p>

          <ul>
            <li className="text-m">
              является субъектом персональных данных, указанных им в анкете при
              регистрации, а именно: фамилии, имени, отчества, адреса постоянной
              регистрации (прописки) и пребывания на территории РФ, а равно иных
              персональных данных;
            </li>
            <li className="text-m">
              ознакомлен с тем, что сбор, хранение, обработка и уничтожение его
              персональных данных будут осуществлены ООО фирма «ВОДОКОМФОРТ»;
            </li>
            <li className="text-m">
              дает свое безусловное и безвозмездное согласие на обработку
              (автоматизированную, а также без использования средств
              автоматизации), включая сбор, систематизацию, накопление,
              хранение, уточнение (обновление, изменение), использование,
              предоставление, обезличивание, блокирование, уничтожение своих
              персональных данных, представленных ООО фирма «ВОДОКОМФОРТ», в
              целях соблюдения законодательства РФ о защите персональных данных
              и в пределах и на условиях, установленных в настоящей Политике
              конфиденциальности;
            </li>
            <li className="text-m">
              об ответственности за достоверность представленных сведений
              предупрежден(а);
            </li>
            <li className="text-m">
              настоящее Согласие действует со дня его предоставления до дня
              отзыва в письменной форме;
            </li>
            <li className="text-m">
              пользователь, как субъект персональных данных, и ООО фирма
              «ВОДОКОМФОРТ» признают днем выдачи и подтверждения настоящего
              согласия календарный день проставления веб-метки о согласии с
              текстом настоящего документа.
            </li>
          </ul>
        </div>

        <div className="main-info w-100 flex-column column-start gap-4x">
          <h4>1. ОБЩИЕ ПОЛОЖЕНИЯ</h4>
          <p className="text-m">
            1.1. В рамках настоящей Политики конфиденциальности под персональной
            информацией Пользователя понимаются: <br /> 1.1.1. Персональная
            информация, которую Пользователь предоставляет о себе самостоятельно
            при регистрации (создании учетной записи) или в процессе
            использования Сервисов, включая персональные данные Пользователя:
            <br />
            1.1.1.1. фамилия, имя, отчество; <br />
            1.1.1.2. дата рождения; <br />
            1.1.1.3. номер основного документа, удостоверяющего личность,
            сведения о дате выдачи указанного документа и выдавшем его органе
            (если требуется); <br />
            1.1.1.4. номер контактного телефона; <br />
            1.1.1.5. адрес электронной почты; <br />
            1.1.1.6. почтовый адрес <br />
            1.1.1.7. реквизиты банковского счета (если требуется), которые
            используются в следующих целях: <br />- для исполнения ООО фирма
            «ВОДОКОМФОРТ» своих обязанностей по договору со мной; <br />- для
            обработки и доставки заказов ООО фирма «ВОДОКОМФОРТ», в том числе
            для предоставления почтовой (транспортной) компании для доставки
            приобретенного Товара в адрес Пользователя); <br />- для
            актуализации предоставленных Пользователем данных. <br />
            1.1.1.8. иные данные, предоставленные Пользователем добровольно при
            использовании Сайта и для целей такого использования – если такие
            данные сами по себе или в совокупности с другими данными позволяют
            идентифицировать Пользователя как определенное физическое лицо.
            Обязательная для предоставления Сервисов информация помечена
            специальным образом. <br />
            1.1.2. Данные, которые автоматически передаются сервисам Сайта в
            процессе их использования с помощью установленного на устройстве
            Пользователя программного обеспечения, в том числе IP-адрес, данные
            файлов cookie, информация о браузере Пользователя (или иной
            программе, с помощью которой осуществляется доступ к сервисам),
            технические характеристики оборудования и программного обеспечения,
            используемых Пользователем, дата и время доступа к сервисам, адреса
            запрашиваемых страниц и иная подобная информация, если такие данные
            сами по себе или в совокупности с другими данными позволяют
            идентифицировать Пользователя как определенное физическое лицо.
            <br />
            1.1.3. Настоящая Политика конфиденциальности применяется только к
            сайту{" "}
            <a href="https://aquastrong-select.ru">www.aquastrong-select.ru</a>.
            Сайт не контролирует и не несет ответственности за сайты третьих
            лиц, на которые Пользователь может перейти по ссылкам, доступным на
            сайте{" "}
            <a href="https://aquastrong-select.ru">www.aquastrong-select.ru</a>
          </p>
        </div>

        <div className="purposes-info w-100 flex-column column-start gap-4x">
          <h4>2. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ</h4>
          <p className="text-m">
            2.1. ООО фирма «ВОДОКОМФОРТ» собирает и хранит только ту
            персональную информацию, которая необходима для предоставления
            сервисов, размещённых на Сайте, или исполнения соглашений и
            договоров с Пользователем, за исключением случаев, когда
            законодательством предусмотрено обязательное хранение персональной
            информации в течение определенного законом срока. В случае получения
            уведомления от Пользователя об отзыве согласия на обработку
            персональных данных Сайт прекращает обработку персональных данных
            Пользователя в срок, не превышающий 10 (десять) рабочих дней с
            момента получения. Уведомление об отзыве согласия на обработку
            персональных данных направляется на адрес электронной почты{" "}
            <a href="mailto:info@vodokomfort.ru"> info@vodokomfort.ru</a>, а
            также путем письменного обращения по адресу: 115114, г. Москва, ул.
            Кожевническая, д. 16, стр. 4.
            <br />
            2.2. Персональную информацию Пользователя ООО фирма «ВОДОКОМФОРТ»
            обрабатывает в следующих целях:
            <br />
            2.2.1. Идентификации Пользователя, зарегистрированного на Сайте, для
            предоставления сервисов, размещённых на Сайте.
            <br />
            2.2.2. Предоставления Пользователю доступа к персонализированным
            ресурсам Сайта.
            <br />
            2.2.3. Установления с Пользователем обратной связи, включая
            направление уведомлений, запросов, касающихся использования Сайта,
            оказания услуг, обработку запросов и заявок от Пользователя.
            <br />
            2.2.4. Определения места нахождения Пользователя для обеспечения
            безопасности, предотвращения мошенничества.
            <br />
            2.2.5. Подтверждения достоверности и полноты персональных данных,
            предоставленных Пользователем.
            <br />
            2.2.6. Создания учетной записи для предоставления сервисов,
            размещённых на Сайте, если Пользователь дал согласие на создание
            учетной записи.
            <br />
            2.2.7. Уведомления Пользователя Сайта о состоянии заявки на подбор
            насосного оборудования.
            <br />
            2.2.8. Предоставления Пользователю эффективной клиентской и
            технической поддержки при возникновении проблем, связанных с
            использованием Сайта.
            <br />
            2.2.9. Осуществления рекламной деятельности с согласия Пользователя.
          </p>
        </div>

        <div className="conditions-info w-100 flex-column column-start gap-4x">
          <h4>
            3. УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ И ЕЕ
            ПЕРЕДАЧИ ТРЕТЬИМ ЛИЦАМ
          </h4>
          <p className="text-m">
            3.1. ООО фирма «ВОДОКОМФОРТ» обрабатывает персональную информацию
            Пользователей в соответствии с Федеральным законом от 27 июля 2006
            г. N 152-ФЗ «О персональных данных» и иными нормативными правовыми
            актами в области обработки и обеспечения безопасности персональных
            данных в соответствии с действующим законодательством Российской
            Федерации.
            <br />
            3.2. В отношении персональной информации Пользователя сохраняется ее
            конфиденциальность, кроме случаев добровольного предоставления
            Пользователем информации о себе для общего доступа неограниченному
            кругу лиц. При использовании отдельных сервисов Пользователь
            соглашается с тем, что определенная часть его персональной
            информации становится общедоступной.
            <br />
            3.3. ООО фирма «ВОДОКОМФОРТ» вправе передать персональную информацию
            Пользователя третьим лицам в следующих случаях:
            <br />
            3.3.1. Пользователь выразил согласие на такие действия.
            <br />
            3.3.2. Передача необходима для использования Пользователем
            определенного сервиса, размещённого на Сайте, либо для исполнения
            определенного соглашения или договора с Пользователем.
            <br />
            3.3.3. Передача предусмотрена российским или иным применимым
            законодательством в рамках установленной законодательством
            процедуры.
            <br />
            3.3.4. В случае продажи Сайта к приобретателю переходят все
            обязательства по соблюдению условий настоящей Политики
            конфиденциальности применительно к полученной им персональной
            информации.
            <br />
            3.4. Обработка персональных данных Пользователя осуществляется без
            ограничения срока следующими способами: сбор, запись,
            систематизация, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передача (распространение,
            предоставление, доступ), обезличивание, блокирование, удаление,
            уничтожение персональных данных, в том числе в информационных
            системах персональных данных с использованием средств автоматизации
            или без использования таких средств. Обработка персональных данных
            Пользователей осуществляется в соответствии с Федеральным законом от
            27.07.2006 N 152-ФЗ «О персональных данных».
            <br />
            3.5. При утрате или разглашении персональных данных ООО фирма
            «ВОДОКОМФОРТ» информирует Пользователя об утрате или разглашении
            персональных данных.
            <br />
            3.6. ООО фирма «ВОДОКОМФОРТ» принимает необходимые организационные и
            технические меры для защиты персональной информации Пользователя от
            неправомерного или случайного доступа, уничтожения, изменения,
            блокирования, копирования, распространения, а также от иных
            неправомерных действий третьих лиц.
            <br />
            3.7. ООО фирма «ВОДОКОМФОРТ» совместно с Пользователем принимает все
            необходимые меры по предотвращению убытков или иных отрицательных
            последствий, вызванных утратой или разглашением персональных данных
            Пользователя.
          </p>
        </div>

        <div className="obligations-info w-100 flex-column column-start gap-4x">
          <h4>4. ОБЯЗАТЕЛЬСТВА СТОРОН</h4>
          <p className="text-m">
            4.1. Пользователь обязуется:
            <br />
            4.1.1. Предоставить информацию о персональных данных, необходимую
            для пользования Сайтом.
            <br />
            4.1.2. Обновлять, дополнять предоставленную информацию о
            персональных данных в случае изменения данной информации.
            <br />
            4.2. ООО фирма «ВОДОКОМФОРТ» обязуется:
            <br />
            4.2.1. Использовать полученную информацию исключительно для целей,
            указанных в настоящей Политике конфиденциальности.
            <br />
            4.2.2. Обеспечить хранение конфиденциальной информации в тайне, не
            разглашать без предварительного письменного разрешения Пользователя,
            а также не осуществлять продажу, обмен, опубликование либо
            разглашение иными возможными способами переданных персональных
            данных Пользователя, за исключением предусмотренных настоящей
            Политикой конфиденциальности.
            <br />
            4.2.3. Для обеспечения защиты персональных данных Пользователя при
            их обработке принимать обычно используемые в существующем деловом
            обороте правовые, организационные и технические меры от
            несанкционированного, неправомерного или случайного доступа к
            персональным данным, уничтожения, изменения, блокирования,
            копирования, предоставления, распространения персональных данных, а
            также от иных неправомерных действий в отношении персональных
            данных.
            <br />
            4.2.4. Осуществить блокирование персональных данных, относящихся к
            соответствующему Пользователю, с момента обращения или запроса
            Пользователя или его законного представителя либо уполномоченного
            органа по защите прав субъектов персональных данных на период
            проверки в случае выявления недостоверных персональных данных или
            неправомерных действий.
          </p>
        </div>

        <div className="responsibility-info w-100 flex-column column-start gap-4x">
          <h4>5. ОТВЕТСТВЕННОСТЬ СТОРОН</h4>
          <p className="text-m">
            5.1. Ответственность ООО фирма «ВОДОКОМФОРТ» за невыполнение
            обязательных требований законодательства Российской Федерации в
            области обработки и обеспечения безопасности персональных данных
            определяется в соответствии с законодательством Российской
            Федерации.
            <br />
            5.2. В случае утраты или разглашения конфиденциальной информации ООО
            фирма «ВОДОКОМФОРТ» не несет ответственности, если данная
            конфиденциальная информация:
            <br />
            5.2.1. Стала публичным достоянием до ее утраты или разглашения.
            <br />
            5.2.2. Была получена от третьей стороны до момента ее получения ООО
            фирма «ВОДОКОМФОРТ».
            <br />
            5.2.3. Была разглашена с согласия Пользователя.
          </p>
        </div>

        <div className="dispute-info w-100 flex-column column-start gap-4x">
          <h4>6. РАЗРЕШЕНИЕ СПОРОВ</h4>
          <p className="text-m">
            6.1. До обращения в суд с иском по спорам, возникающим из отношений
            в рамках обработки персональных данных между Пользователем и ООО
            фирма «ВОДОКОМФОРТ», обязательным является предъявление претензии
            (письменного предложения о добровольном урегулировании спора).
            Сторона высылает претензию по почте заказным письмом с уведомлением
            о вручении или направляет курьером.
            <br />
            6.2. Получатель претензии в течение 30 (тридцати) календарных дней
            со дня получения претензии письменно уведомляет заявителя претензии
            о результатах рассмотрения претензии.
            <br />
            6.3. Если стороны не пришли к соглашению, спор передается на
            рассмотрение Замоскворецкого районного суда г. Москвы.
            <br />
            6.4. К настоящей Политике конфиденциальности и отношениям между
            Пользователем и ООО фирма «ВОДОКОМФОРТ» применяется действующее
            законодательство Российской Федерации.
          </p>
        </div>

        <div className="additional-info w-100 flex-column column-start gap-4x">
          <h4>7. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h4>
          <p className="text-m">
            7.1. ООО фирма «ВОДОКОМФОРТ» вправе вносить изменения в настоящую
            Политику конфиденциальности без согласия Пользователя.
            <br />
            7.2. Новая Политика конфиденциальности вступает в силу с момента ее
            размещения на Сайте, если иное не предусмотрено новой редакцией
            Политики конфиденциальности.
            <br />
            7.3. Все предложения или вопросы по настоящей Политике
            конфиденциальности следует сообщать на электронный адрес:{" "}
            <a href="mailto:info@vodokomfort.ru"> info@vodokomfort.ru</a>.
            <br />
            7.4. Действующая Политика конфиденциальности размещена на странице
            по адресу:{" "}
            <a href="https://aquastrong-select.ru/privacy-policy">
              www.aquastrong-select.ru/privacy-policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
